export const formatDollar = (value: number) => {
  if (!value) return value;

  // remove non-numeric characters from the string
  const cleanedString = value.toString().replace(/[^\d.]/g, '');
  // split the string into dollars and cents
  let [dollars, cents] = cleanedString.split('.');

  // remove leading zeros
  if (dollars.length > 1) dollars = dollars.replace(/^0+/g, '') || '0';
  // add commas where appropriate
  if (dollars.length >= 3) dollars = dollars.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  // keep only two decimal places
  if (cents !== undefined) cents = cents.substring(0, 2);

  return cents !== undefined ? `${dollars}.${cents}` : dollars;
};
